var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"contents":_vm.contents,"prevRoute":_vm.prevRoute},on:{"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }